

import { ref, computed } from 'vue';
import moment from 'moment';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import i18n, { EN, ZH, ZH_HK } from '@/locales';
import { formatterColTransferUnit } from '@/utils/format';

const useCurrentReactive = () => {
    const { top_ten_shareholder_dates, top_ten_shareholder } = useModuleData();
    const dateRange = ref([]);
    const activeDate = ref('');
    const activeTab = ref(1);

    function filterRecentDates(dates) {
        // 获取当前日期
        const now = moment();
        // 计算两年前的日期
        const twoYearsAgo = now.subtract(2, 'years').startOf('year');
        // 保留近两年内的日期
        const filteredDates = dates.filter(dateStr => {
            const date = moment(dateStr);
            return date.isSameOrAfter(twoYearsAgo);
        });
        return filteredDates;
    }

    const loadDateList = async () => {
        await top_ten_shareholder_dates.refresh({
            type: activeTab.value
        });
        const result = top_ten_shareholder_dates.data?.data || [];

        const recentDates = filterRecentDates(result);
        const dateList = recentDates.map(v => {
            return {
                text: v,
                label: v,
                value: moment(v).valueOf()
            };
        });
        if (dateList.length) {
            activeDate.value = dateList[0].value;
            dateRange.value = dateList;
        }

    };

    const loadData = async date => {
        await top_ten_shareholder.refresh({
            timestamp: date,
            type: activeTab.value
        });
    };

    const tabs = computed(() => [
        {
            label: i18n.t('enterprise.top-10-holders'),
            value: 1
        },
        {
            label: i18n.t('enterprise.top-10-float-holders'),
            value: 2
        }
    ]);

    const changeStatuMap = {
        [EN]: 'holdingsChangeStatusEn',
        [ZH_HK]: 'holdingsChangeStatusCht',
        [ZH]: 'holdingsChangeStatus'
    };

    // 保持与历史组件相同的数据访问路径
    const tabData = computed(() => {
        const result = top_ten_shareholder.data?.data || [];
        return result.data
            ? result.data.map(item => ({
                ...item,
                changeStatus: item[changeStatuMap[i18n.locale]]
            }))
            : [];
    });

    const formatterProgress = value => {
        if (!value) return '0%';
        return `${value.toFixed(2)}%`;
    };

    const formatterTransferUnit = value => {
        return formatterColTransferUnit(value, true);
    };
    const formatterRadio = value => {
        if (!value) return '-';
        return `${value.toFixed(2)}%`;
    };

    return {
        dateRange,
        activeDate,
        activeTab,
        loadDateList,
        loadData,
        top_ten_shareholder,
        tabs,
        tabData,
        formatterProgress,
        formatterTransferUnit,
        formatterRadio
    }
}

export { useCurrentReactive };